export const getPurchaseNumber = () => {
  const purchaseNumber = new Date().getTime().toString().slice(1)
  return purchaseNumber
}
